// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorsCard-cls1_0Mw","cls2":"AuthorsCard-cls2_s96 AuthorsCard-cls1_0Mw","altLook":"AuthorsCard-altLook_b9S"};